import type { BoxProps } from '@hover/blueprint';
import { Box } from '@hover/blueprint';
import React from 'react';

const Aside = (props: BoxProps) => (
  <Box
    alignItems="center"
    flex={{ base: 0, tablet: 2 }}
    justifyContent="center"
    order={{ base: 0, tablet: 2 }}
    {...props}
  />
);

export { Aside };
